"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5652],{

/***/ 40696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44976);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        width: "16",
        height: "17",
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M7.95854 3.83325L14.1554 11.4999L1.76165 11.4999L7.95854 3.83325Z",
            fill: props.color
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 13351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ LocalContext; },
/* harmony export */   "Z": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9473);



var LocalContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(null);
/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(param) {
    var children = param.children, store = param.store;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_redux__WEBPACK_IMPORTED_MODULE_2__/* .Provider */ .zt, {
        store: store,
        context: LocalContext,
        children: children
    });
};


/***/ }),

/***/ 29807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useLocalDispatch; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var lodash_noop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50308);
/* harmony import */ var lodash_noop__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_noop__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Provider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13351);



function useLocalDispatch() {
    var ref;
    var localContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_Provider__WEBPACK_IMPORTED_MODULE_2__/* .LocalContext */ .A);
    var emptyFn = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((lodash_noop__WEBPACK_IMPORTED_MODULE_1___default()), []);
    return (localContext === null || localContext === void 0 ? void 0 : (ref = localContext.store) === null || ref === void 0 ? void 0 : ref.dispatch) || emptyFn;
}


/***/ }),

/***/ 81272:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ck": function() { return /* binding */ REWARD_RATE; },
/* harmony export */   "ND": function() { return /* binding */ FUTURE_ROUND_COUNT; },
/* harmony export */   "eQ": function() { return /* binding */ LEADERBOARD_MIN_ROUNDS_PLAYED; },
/* harmony export */   "fq": function() { return /* binding */ ROUND_BUFFER; },
/* harmony export */   "v9": function() { return /* binding */ PAST_ROUND_COUNT; },
/* harmony export */   "yg": function() { return /* binding */ ROUNDS_PER_PAGE; }
/* harmony export */ });
/* harmony import */ var config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97478);

var REWARD_RATE = 1 - 0.03 // CHANGE RATE
;
// Estimated number of seconds it takes to submit a transaction (3 blocks) in seconds
var ROUND_BUFFER = config__WEBPACK_IMPORTED_MODULE_0__/* .BSC_BLOCK_TIME */ .hJ * 3;
var PAST_ROUND_COUNT = 5;
var FUTURE_ROUND_COUNT = 2;
var ROUNDS_PER_PAGE = 200;
var LEADERBOARD_MIN_ROUNDS_PLAYED = 10;


/***/ }),

/***/ 79279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ub": function() { return /* binding */ LEADERBOARD_RESULTS_PER_PAGE; },
  "x4": function() { return /* binding */ Result; },
  "oO": function() { return /* binding */ fetchUserRounds; },
  "t$": function() { return /* binding */ fetchUsersRoundsLength; },
  "Fr": function() { return /* binding */ getBetHistory; },
  "QI": function() { return /* binding */ getBetLeaderboard; },
  "jG": function() { return /* binding */ getClaimStatuses; },
  "fq": function() { return /* binding */ getFilteredBets; },
  "HJ": function() { return /* binding */ getHasRoundFailed; },
  "Tq": function() { return /* binding */ getLedgerData; },
  "n": function() { return /* binding */ getPredictionData; },
  "s9": function() { return /* binding */ getPredictionUser; },
  "D": function() { return /* binding */ getPredictionUsers; },
  "yz": function() { return /* binding */ getRoundResult; },
  "$8": function() { return /* binding */ getRoundsData; },
  "CM": function() { return /* binding */ makeFutureRoundResponse; },
  "a8": function() { return /* binding */ makeLedgerData; },
  "D5": function() { return /* binding */ makeRoundData; },
  "zN": function() { return /* binding */ parseBigNumberObj; },
  "WB": function() { return /* binding */ serializePredictionsRoundsResponse; },
  "ld": function() { return /* binding */ transformBetResponse; },
  "r3": function() { return /* binding */ transformUserResponse; }
});

// UNUSED EXPORTS: getTotalWon, serializePredictionsLedgerResponse

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/graphql-request/dist/index.js
var dist = __webpack_require__(28687);
// EXTERNAL MODULE: ./src/config/constants/endpoints.ts
var endpoints = __webpack_require__(6680);
// EXTERNAL MODULE: ./node_modules/@ethersproject/bignumber/lib.esm/bignumber.js
var bignumber = __webpack_require__(2593);
// EXTERNAL MODULE: ./src/state/types.ts
var types = __webpack_require__(96470);
// EXTERNAL MODULE: ./src/utils/multicall.ts
var multicall = __webpack_require__(9796);
// EXTERNAL MODULE: ./src/utils/contractHelpers.ts + 25 modules
var contractHelpers = __webpack_require__(21421);
// EXTERNAL MODULE: ./src/config/abi/predictions.json
var predictions = __webpack_require__(45883);
// EXTERNAL MODULE: ./node_modules/@ethersproject/constants/lib.esm/bignumbers.js
var bignumbers = __webpack_require__(21046);
;// CONCATENATED MODULE: ./src/state/predictions/bnbQueries.ts
/**
 * Base fields are the all the top-level fields available in the api. Used in multiple queries
 */ var roundBaseFields = "\n  id\n  epoch\n  position\n  failed\n  startAt\n  startBlock\n  startHash\n  lockAt\n  lockBlock\n  lockHash\n  lockPrice\n  lockRoundId\n  closeAt\n  closeBlock\n  closeHash\n  closePrice\n  closeRoundId\n  totalBets\n  totalAmount\n  bullBets\n  bullAmount\n  bearBets\n  bearAmount\n";
var betBaseFields = "\n id\n hash  \n amount\n position\n claimed\n claimedAt\n claimedHash\n claimedBlock\n claimedBNB\n claimedNetBNB\n createdAt\n updatedAt\n";
var userBaseFields = "\n  id\n  createdAt\n  updatedAt\n  block\n  totalBets\n  totalBetsBull\n  totalBetsBear\n  totalBNB\n  totalBNBBull\n  totalBNBBear\n  totalBetsClaimed\n  totalBNBClaimed\n  winRate\n  averageBNB\n  netBNB\n";

;// CONCATENATED MODULE: ./src/state/predictions/cakeQueries.ts
/**
 * Base fields are the all the top-level fields available in the api. Used in multiple queries
 */ var cakeQueries_roundBaseFields = "\n  id\n  epoch\n  position\n  failed\n  startAt\n  startBlock\n  startHash\n  lockAt\n  lockBlock\n  lockHash\n  lockPrice\n  lockRoundId\n  closeAt\n  closeBlock\n  closeHash\n  closePrice\n  closeRoundId\n  totalBets\n  totalAmount\n  bullBets\n  bullAmount\n  bearBets\n  bearAmount\n";
// export const betBaseFields = `
//  id
//  hash
//  amount
//  position
//  claimed
//  claimedAt
//  claimedHash
//  claimedBlock
// claimedCAKE
//  claimedNetCAKE
//  createdAt
//  updatedAt
// `
var cakeQueries_betBaseFields = "\n id\n hash  \n amount\n position\n claimed\n claimedAt\n claimedHash\n claimedBlock\n createdAt\n updatedAt\n claimedNetETH\n";
var cakeQueries_userBaseFields = "\n  id\n  createdAt\n  updatedAt\n  block\n  totalBets\n  totalBetsBull\n  totalBetsBear\n  totalCAKE\n  totalCAKEBull\n  totalCAKEBear\n  totalBetsClaimed\n  totalCAKEClaimed\n  winRate\n  averageCAKE\n  netCAKE\n";
var userBaseFieldsOP = "\n  winRate\n  updatedAt\n  totalETHClaimed\n  totalETHBull\n  totalETHBear\n  totalETH\n  totalBetsClaimed\n  totalBetsBull\n  totalBetsBear\n  totalBets\n  netETH\n  id\n  createdAt\n  block\n  averageETH\n"//   averageOP
//  netOP
;

;// CONCATENATED MODULE: ./src/state/predictions/queries.ts


var getRoundBaseFields = function(tokenSymbol) {
    return tokenSymbol === "CAKE" ? cakeQueries_roundBaseFields : roundBaseFields;
};
var getBetBaseFields = function(tokenSymbol) {
    return tokenSymbol === "CAKE" ? cakeQueries_betBaseFields : betBaseFields;
};
var getUserBaseFields = function(tokenSymbol) {
    return(// tokenSymbol === 'CAKE' ? userBaseFieldsCAKE : userBaseFieldsBNB
    tokenSymbol === "CAKE" ? userBaseFieldsOP : userBaseFields);
};

// EXTERNAL MODULE: ./src/state/predictions/config.ts
var config = __webpack_require__(81272);
;// CONCATENATED MODULE: ./src/utils/numberOrNull.ts
var numberOrNull = function(value) {
    if (value === null) {
        return null;
    }
    var valueNum = Number(value);
    return Number.isNaN(valueNum) ? null : valueNum;
};
/* harmony default export */ var utils_numberOrNull = (numberOrNull);

;// CONCATENATED MODULE: ./src/state/predictions/cakeTransformers.ts


var getRoundPosition = function(positionResponse) {
    if (positionResponse === "Bull") {
        return types/* BetPosition.BULL */.Tu.BULL;
    }
    if (positionResponse === "Bear") {
        return types/* BetPosition.BEAR */.Tu.BEAR;
    }
    if (positionResponse === "House") {
        return types/* BetPosition.HOUSE */.Tu.HOUSE;
    }
    return null;
};
var transformBetResponseCAKE = function(betResponse) {
    var bet = {
        id: betResponse.id,
        hash: betResponse.hash,
        block: utils_numberOrNull(betResponse.block),
        amount: betResponse.amount ? parseFloat(betResponse.amount) : 0,
        position: betResponse.position === "Bull" ? types/* BetPosition.BULL */.Tu.BULL : types/* BetPosition.BEAR */.Tu.BEAR,
        claimed: betResponse.claimed,
        claimedAt: utils_numberOrNull(betResponse.claimedAt),
        claimedBlock: utils_numberOrNull(betResponse.claimedBlock),
        claimedHash: betResponse.claimedHash,
        claimedBNB: betResponse.claimedCAKE ? parseFloat(betResponse.claimedCAKE) : 0,
        claimedNetBNB: betResponse.claimedNetCAKE ? parseFloat(betResponse.claimedNetCAKE) : 0,
        createdAt: utils_numberOrNull(betResponse.createdAt),
        updatedAt: utils_numberOrNull(betResponse.updatedAt)
    };
    if (betResponse.user) {
        bet.user = transformUserResponseCAKE(betResponse.user);
    }
    if (betResponse.round) {
        bet.round = transformRoundResponseCAKE(betResponse.round);
    }
    return bet;
};
// export const transformUserResponseCAKE = (userResponse): PredictionUser => {
//   const {
//     id,
//     createdAt,
//     updatedAt,
//     block,
//     totalBets,
//     totalBetsBull,
//     totalBetsBear,
//     totalCAKE,
//     totalCAKEBull,
//     totalCAKEBear,
//     totalBetsClaimed,
//     totalCAKEClaimed,
//     winRate,
//     averageCAKE,
//     netCAKE,
//   } = userResponse || {}
//   return {
//     id,
//     createdAt: numberOrNull(createdAt),
//     updatedAt: numberOrNull(updatedAt),
//     block: numberOrNull(block),
//     totalBets: numberOrNull(totalBets),
//     totalBetsBull: numberOrNull(totalBetsBull),
//     totalBetsBear: numberOrNull(totalBetsBear),
//     totalBNB: totalCAKE ? parseFloat(totalCAKE) : 0,
//     totalBNBBull: totalCAKEBull ? parseFloat(totalCAKEBull) : 0,
//     totalBNBBear: totalCAKEBear ? parseFloat(totalCAKEBear) : 0,
//     totalBetsClaimed: numberOrNull(totalBetsClaimed),
//     totalBNBClaimed: totalCAKEClaimed ? parseFloat(totalCAKEClaimed) : 0,
//     winRate: winRate ? parseFloat(winRate) : 0,
//     averageBNB: averageCAKE ? parseFloat(averageCAKE) : 0,
//     netBNB: netCAKE ? parseFloat(netCAKE) : 0,
//   }
// }
var transformUserResponseCAKE = function(userResponse) {
    var ref = userResponse || {}, id = ref.id, createdAt = ref.createdAt, updatedAt = ref.updatedAt, block = ref.block, totalBets = ref.totalBets, totalBetsBull = ref.totalBetsBull, totalBetsBear = ref.totalBetsBear, totalETH = ref.totalETH, totalETHBull = ref.totalETHBull, totalETHBear = ref.totalETHBear, totalBetsClaimed = ref.totalBetsClaimed, totalETHClaimed = ref.totalETHClaimed, winRate = ref.winRate, averageETH = ref.averageETH, netETH = ref.netETH;
    return {
        id: id,
        createdAt: utils_numberOrNull(createdAt),
        updatedAt: utils_numberOrNull(updatedAt),
        block: utils_numberOrNull(block),
        totalBets: utils_numberOrNull(totalBets),
        totalBetsBull: utils_numberOrNull(totalBetsBull),
        totalBetsBear: utils_numberOrNull(totalBetsBear),
        totalETH: totalETH ? parseFloat(totalETH) : 0,
        totalETHBull: totalETHBull ? parseFloat(totalETHBull) : 0,
        totalETHBear: totalETHBear ? parseFloat(totalETHBear) : 0,
        totalBetsClaimed: utils_numberOrNull(totalBetsClaimed),
        totalETHClaimed: totalETHClaimed ? parseFloat(totalETHClaimed) : 0,
        winRate: winRate ? parseFloat(winRate) : 0,
        averageETH: averageETH ? parseFloat(averageETH) : 0,
        netETH: netETH ? parseFloat(netETH) : 0
    };
};
var transformRoundResponseCAKE = function(roundResponse) {
    var id = roundResponse.id, epoch = roundResponse.epoch, failed = roundResponse.failed, position = roundResponse.position, startAt = roundResponse.startAt, startBlock = roundResponse.startBlock, startHash = roundResponse.startHash, lockAt = roundResponse.lockAt, lockBlock = roundResponse.lockBlock, lockHash = roundResponse.lockHash, lockPrice = roundResponse.lockPrice, lockRoundId = roundResponse.lockRoundId, closeAt = roundResponse.closeAt, closeBlock = roundResponse.closeBlock, closeHash = roundResponse.closeHash, closePrice = roundResponse.closePrice, closeRoundId = roundResponse.closeRoundId, totalBets = roundResponse.totalBets, totalAmount = roundResponse.totalAmount, bullBets = roundResponse.bullBets, bullAmount = roundResponse.bullAmount, bearBets = roundResponse.bearBets, bearAmount = roundResponse.bearAmount, _bets = roundResponse.bets, bets = _bets === void 0 ? [] : _bets;
    return {
        id: id,
        failed: failed,
        startHash: startHash,
        lockHash: lockHash,
        lockRoundId: lockRoundId,
        closeRoundId: closeRoundId,
        closeHash: closeHash,
        position: getRoundPosition(position),
        epoch: utils_numberOrNull(epoch),
        startAt: utils_numberOrNull(startAt),
        startBlock: utils_numberOrNull(startBlock),
        lockAt: utils_numberOrNull(lockAt),
        lockBlock: utils_numberOrNull(lockBlock),
        lockPrice: lockPrice ? parseFloat(lockPrice) : 0,
        closeAt: utils_numberOrNull(closeAt),
        closeBlock: utils_numberOrNull(closeBlock),
        closePrice: closePrice ? parseFloat(closePrice) : 0,
        totalBets: utils_numberOrNull(totalBets),
        totalAmount: totalAmount ? parseFloat(totalAmount) : 0,
        bullBets: utils_numberOrNull(bullBets),
        bullAmount: bullAmount ? parseFloat(bullAmount) : 0,
        bearBets: utils_numberOrNull(bearBets),
        bearAmount: bearAmount ? parseFloat(bearAmount) : 0,
        bets: bets.map(transformBetResponseCAKE)
    };
};

;// CONCATENATED MODULE: ./src/state/predictions/bnbTransformers.ts


var bnbTransformers_getRoundPosition = function(positionResponse) {
    if (positionResponse === "Bull") {
        return types/* BetPosition.BULL */.Tu.BULL;
    }
    if (positionResponse === "Bear") {
        return types/* BetPosition.BEAR */.Tu.BEAR;
    }
    if (positionResponse === "House") {
        return types/* BetPosition.HOUSE */.Tu.HOUSE;
    }
    return null;
};
var transformBetResponseBNB = function(betResponse) {
    var bet = {
        id: betResponse.id,
        hash: betResponse.hash,
        block: utils_numberOrNull(betResponse.block),
        amount: betResponse.amount ? parseFloat(betResponse.amount) : 0,
        position: betResponse.position === "Bull" ? types/* BetPosition.BULL */.Tu.BULL : types/* BetPosition.BEAR */.Tu.BEAR,
        claimed: betResponse.claimed,
        claimedAt: utils_numberOrNull(betResponse.claimedAt),
        claimedBlock: utils_numberOrNull(betResponse.claimedBlock),
        claimedHash: betResponse.claimedHash,
        claimedBNB: betResponse.claimedBNB ? parseFloat(betResponse.claimedBNB) : 0,
        claimedNetBNB: betResponse.claimedNetBNB ? parseFloat(betResponse.claimedNetBNB) : 0,
        createdAt: utils_numberOrNull(betResponse.createdAt),
        updatedAt: utils_numberOrNull(betResponse.updatedAt)
    };
    if (betResponse.user) {
        bet.user = transformUserResponseBNB(betResponse.user);
    }
    if (betResponse.round) {
        bet.round = transformRoundResponseBNB(betResponse.round);
    }
    return bet;
};
// export const transformUserResponseBNB = (userResponse): PredictionUser => {
//   const {
//     id,
//     createdAt,
//     updatedAt,
//     block,
//     totalBets,
//     totalBetsBull,
//     totalBetsBear,
//     totalBNB,
//     totalBNBBull,
//     totalBNBBear,
//     totalBetsClaimed,
//     totalBNBClaimed,
//     winRate,
//     averageBNB,
//     netBNB,
//   } = userResponse || {}
//   return {
//     id,
//     createdAt: numberOrNull(createdAt),
//     updatedAt: numberOrNull(updatedAt),
//     block: numberOrNull(block),
//     totalBets: numberOrNull(totalBets),
//     totalBetsBull: numberOrNull(totalBetsBull),
//     totalBetsBear: numberOrNull(totalBetsBear),
//     totalBNB: totalBNB ? parseFloat(totalBNB) : 0,
//     totalBNBBull: totalBNBBull ? parseFloat(totalBNBBull) : 0,
//     totalBNBBear: totalBNBBear ? parseFloat(totalBNBBear) : 0,
//     totalBetsClaimed: numberOrNull(totalBetsClaimed),
//     totalBNBClaimed: totalBNBClaimed ? parseFloat(totalBNBClaimed) : 0,
//     winRate: winRate ? parseFloat(winRate) : 0,
//     averageBNB: averageBNB ? parseFloat(averageBNB) : 0,
//     netBNB: netBNB ? parseFloat(netBNB) : 0,
//   }
// }
var transformUserResponseBNB = function(userResponse) {
    var ref = userResponse || {}, id = ref.id, createdAt = ref.createdAt, updatedAt = ref.updatedAt, block = ref.block, totalBets = ref.totalBets, totalBetsBull = ref.totalBetsBull, totalBetsBear = ref.totalBetsBear, totalETH = ref.totalETH, totalETHBull = ref.totalETHBull, totalETHBear = ref.totalETHBear, totalBetsClaimed = ref.totalBetsClaimed, totalETHClaimed = ref.totalETHClaimed, winRate = ref.winRate, averageETH = ref.averageETH, netETH = ref.netETH;
    return {
        id: id,
        createdAt: utils_numberOrNull(createdAt),
        updatedAt: utils_numberOrNull(updatedAt),
        block: utils_numberOrNull(block),
        totalBets: utils_numberOrNull(totalBets),
        totalBetsBull: utils_numberOrNull(totalBetsBull),
        totalBetsBear: utils_numberOrNull(totalBetsBear),
        totalETH: totalETH ? parseFloat(totalETH) : 0,
        totalETHBull: totalETHBull ? parseFloat(totalETHBull) : 0,
        totalETHBear: totalETHBear ? parseFloat(totalETHBear) : 0,
        totalBetsClaimed: utils_numberOrNull(totalBetsClaimed),
        totalETHClaimed: totalETHClaimed ? parseFloat(totalETHClaimed) : 0,
        winRate: winRate ? parseFloat(winRate) : 0,
        averageETH: averageETH ? parseFloat(averageETH) : 0,
        netETH: netETH ? parseFloat(netETH) : 0
    };
};
var transformRoundResponseBNB = function(roundResponse) {
    var id = roundResponse.id, epoch = roundResponse.epoch, failed = roundResponse.failed, position = roundResponse.position, startAt = roundResponse.startAt, startBlock = roundResponse.startBlock, startHash = roundResponse.startHash, lockAt = roundResponse.lockAt, lockBlock = roundResponse.lockBlock, lockHash = roundResponse.lockHash, lockPrice = roundResponse.lockPrice, lockRoundId = roundResponse.lockRoundId, closeAt = roundResponse.closeAt, closeBlock = roundResponse.closeBlock, closeHash = roundResponse.closeHash, closePrice = roundResponse.closePrice, closeRoundId = roundResponse.closeRoundId, totalBets = roundResponse.totalBets, totalAmount = roundResponse.totalAmount, bullBets = roundResponse.bullBets, bullAmount = roundResponse.bullAmount, bearBets = roundResponse.bearBets, bearAmount = roundResponse.bearAmount, _bets = roundResponse.bets, bets = _bets === void 0 ? [] : _bets;
    return {
        id: id,
        failed: failed,
        startHash: startHash,
        lockHash: lockHash,
        lockRoundId: lockRoundId,
        closeRoundId: closeRoundId,
        closeHash: closeHash,
        position: bnbTransformers_getRoundPosition(position),
        epoch: utils_numberOrNull(epoch),
        startAt: utils_numberOrNull(startAt),
        startBlock: utils_numberOrNull(startBlock),
        lockAt: utils_numberOrNull(lockAt),
        lockBlock: utils_numberOrNull(lockBlock),
        lockPrice: lockPrice ? parseFloat(lockPrice) : 0,
        closeAt: utils_numberOrNull(closeAt),
        closeBlock: utils_numberOrNull(closeBlock),
        closePrice: closePrice ? parseFloat(closePrice) : 0,
        totalBets: utils_numberOrNull(totalBets),
        totalAmount: totalAmount ? parseFloat(totalAmount) : 0,
        bullBets: utils_numberOrNull(bullBets),
        bullAmount: bullAmount ? parseFloat(bullAmount) : 0,
        bearBets: utils_numberOrNull(bearBets),
        bearAmount: bearAmount ? parseFloat(bearAmount) : 0,
        bets: bets.map(transformBetResponseBNB)
    };
};

;// CONCATENATED MODULE: ./src/state/predictions/helpers.ts







function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        query getTotalWonData {\n          market(id: 1) {\n            totalBNB\n            totalBNBTreasury\n          }\n        }\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        query getTotalWonData {\n          market(id: 1) {\n            totalCAKE\n            totalCAKETreasury\n          }\n        }\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      query getBetHistory($first: Int!, $skip: Int!, $where: Bet_filter) {\n        bets(first: $first, skip: $skip, where: $where, orderBy: createdAt, orderDirection: desc) {\n          ",
        "\n          round {\n            ",
        "\n          }\n          user {\n            ",
        "\n          }\n        }\n      }\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      query getBetLeaderboard($first: Int!, $skip: Int!, $where: Bet_filter) {\n        users(where: $where) {\n          winRate\n          netETH\n          totalETH\n          averageETH\n          totalBetsClaimed\n          totalBets\n          bets(first: $first, orderBy: createdAt, orderDirection: desc) {\n            ",
        "\n            round {\n              ",
        "\n            }\n          }\n        }\n      }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      query getUsers($first: Int!, $skip: Int!, $orderBy: String!, $orderDir: String!) {\n        users(first: $first, skip: $skip, where: $where, orderBy: $orderBy, orderDirection: $orderDir) {\n          ",
        "\n        }\n      }\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      query getUser($id: ID!) {\n        user(id: $id) {\n          ",
        "\n        }\n      }\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}












var Result;
(function(Result) {
    Result["WIN"] = "win";
    Result["LOSE"] = "lose";
    Result["CANCELED"] = "canceled";
    Result["HOUSE"] = "house";
    Result["LIVE"] = "live";
})(Result || (Result = {}));
var transformBetResponse = function(tokenSymbol) {
    return tokenSymbol === "CAKE" ? transformBetResponseCAKE : transformBetResponseBNB;
};
var transformUserResponse = function(tokenSymbol) {
    return tokenSymbol === "CAKE" ? transformUserResponseCAKE : transformUserResponseBNB;
};
var getRoundResult = function(bet, currentEpoch) {
    var round = bet.round;
    if (round.failed) {
        return Result.CANCELED;
    }
    if (round.epoch >= currentEpoch - 1) {
        return Result.LIVE;
    }
    if (bet.round.position === types/* BetPosition.HOUSE */.Tu.HOUSE) {
        return Result.HOUSE;
    }
    var roundResultPosition = round.closePrice > round.lockPrice ? types/* BetPosition.BULL */.Tu.BULL : types/* BetPosition.BEAR */.Tu.BEAR;
    return bet.position === roundResultPosition ? Result.WIN : Result.LOSE;
};
var getFilteredBets = function(bets, filter) {
    switch(filter){
        case types/* HistoryFilter.COLLECTED */.dZ.COLLECTED:
            return bets.filter(function(bet) {
                return bet.claimed === true;
            });
        case types/* HistoryFilter.UNCOLLECTED */.dZ.UNCOLLECTED:
            return bets.filter(function(bet) {
                return !bet.claimed && (bet.position === bet.round.position || bet.round.failed === true);
            });
        case types/* HistoryFilter.ALL */.dZ.ALL:
        default:
            return bets;
    }
};
var getTotalWonMarket = function(market, tokenSymbol) {
    var total = market["total".concat(tokenSymbol)] ? parseFloat(market["total".concat(tokenSymbol)]) : 0;
    var totalTreasury = market["total".concat(tokenSymbol, "Treasury")] ? parseFloat(market["total".concat(tokenSymbol, "Treasury")]) : 0;
    return Math.max(total - totalTreasury, 0);
};
var getTotalWon = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var ref, ref1, BNBMarket, CAKEMarket, totalWonBNB, totalWonCAKE;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        Promise.all([
                            (0,dist.request)(endpoints/* GRAPH_API_PREDICTION_BNB */.GZ, (0,dist.gql)(_templateObject())),
                            (0,dist.request)(endpoints/* GRAPH_API_PREDICTION_CAKE */.fO, (0,dist.gql)(_templateObject1()))
                        ])
                    ];
                case 1:
                    ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        1
                    ]), ref1 = ref[0], BNBMarket = ref1.market, CAKEMarket = ref1.market;
                    totalWonBNB = getTotalWonMarket(BNBMarket, "BNB");
                    totalWonCAKE = getTotalWonMarket(CAKEMarket, "CAKE");
                    return [
                        2,
                        {
                            totalWonBNB: totalWonBNB,
                            totalWonCAKE: totalWonCAKE
                        }
                    ];
            }
        });
    });
    return function getTotalWon() {
        return _ref.apply(this, arguments);
    };
}();
var getBetHistory = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var where, first, skip, api, tokenSymbol, response;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    where = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, first = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 1000, skip = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 0, api = _arguments.length > 3 ? _arguments[3] : void 0, tokenSymbol = _arguments.length > 4 ? _arguments[4] : void 0;
                    return [
                        4,
                        (0,dist.request)(api, (0,dist.gql)(_templateObject2(), getBetBaseFields(tokenSymbol), getRoundBaseFields(tokenSymbol), getUserBaseFields(tokenSymbol)), {
                            first: first,
                            skip: skip,
                            where: where
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.bets
                    ];
            }
        });
    });
    return function getBetHistory() {
        return _ref.apply(this, arguments);
    };
}();
var getBetLeaderboard = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var where, first, skip, api, tokenSymbol, response;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    where = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, first = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 1000, skip = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 0, api = _arguments.length > 3 ? _arguments[3] : void 0, tokenSymbol = _arguments.length > 4 ? _arguments[4] : void 0;
                    return [
                        4,
                        (0,dist.request)(api, (0,dist.gql)(_templateObject3(), getBetBaseFields(tokenSymbol), getRoundBaseFields(tokenSymbol)), {
                            first: first,
                            skip: skip,
                            where: where
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response
                    ];
            }
        });
    });
    return function getBetLeaderboard() {
        return _ref.apply(this, arguments);
    };
}();
var getLedgerData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(account, epochs, address) {
        var ledgerCalls, response;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ledgerCalls = epochs.map(function(epoch) {
                        return {
                            address: address,
                            name: "ledger",
                            params: [
                                epoch,
                                account
                            ]
                        };
                    });
                    return [
                        4,
                        (0,multicall/* multicallv3 */.OF)({
                            abi: predictions,
                            calls: ledgerCalls
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response
                    ];
            }
        });
    });
    return function getLedgerData(account, epochs, address) {
        return _ref.apply(this, arguments);
    };
}();
var LEADERBOARD_RESULTS_PER_PAGE = 10 // 20
;
var defaultPredictionUserOptions = {
    skip: 0,
    first: LEADERBOARD_RESULTS_PER_PAGE,
    orderBy: "createdAt",
    orderDir: "desc"
};
var getHasRoundFailed = function(oracleCalled, closeTimestamp, buffer) {
    if (!oracleCalled) {
        var closeTimestampMs = (closeTimestamp + buffer) * 1000;
        if (Number.isFinite(closeTimestampMs)) {
            return Date.now() > closeTimestampMs;
        }
    }
    return false;
};
// fix later
var getPredictionUsers = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var options, api, tokenSymbol, ref, first, skip, where, orderBy, orderDir, response;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    options = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, api = _arguments.length > 1 ? _arguments[1] : void 0, tokenSymbol = _arguments.length > 2 ? _arguments[2] : void 0;
                    ref = (0,_object_spread/* default */.Z)({}, defaultPredictionUserOptions, options), first = ref.first, skip = ref.skip, where = ref.where, orderBy = ref.orderBy, orderDir = ref.orderDir;
                    return [
                        4,
                        (0,dist.request)(api, (0,dist.gql)(_templateObject4(), getUserBaseFields(tokenSymbol)), {
                            first: first,
                            skip: skip,
                            where: where,
                            orderBy: orderBy,
                            orderDir: orderDir
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.users.map(function(item) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                netCAKE: item === null || item === void 0 ? void 0 : item.netOP
                            });
                        })
                    ];
            }
        });
    });
    return function getPredictionUsers() {
        return _ref.apply(this, arguments);
    };
}();
var getPredictionUser = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(account, api, tokenSymbol) {
        var response;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,dist.request)(api, (0,dist.gql)(_templateObject5(), getUserBaseFields(tokenSymbol)), {
                            id: account.toLowerCase()
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.user
                    ];
            }
        });
    });
    return function getPredictionUser(account, api, tokenSymbol) {
        return _ref.apply(this, arguments);
    };
}();
var getClaimStatuses = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(account, epochs, address) {
        var claimableCalls, claimableResponses;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    claimableCalls = epochs.map(function(epoch) {
                        return {
                            address: address,
                            name: "claimable",
                            params: [
                                epoch,
                                account
                            ]
                        };
                    });
                    return [
                        4,
                        (0,multicall/* multicallv3 */.OF)({
                            abi: predictions,
                            calls: claimableCalls
                        })
                    ];
                case 1:
                    claimableResponses = _state.sent();
                    return [
                        2,
                        claimableResponses.reduce(function(accum, claimableResponse, index) {
                            var epoch = epochs[index];
                            var _claimableResponse = (0,_sliced_to_array/* default */.Z)(claimableResponse, 1), claimable = _claimableResponse[0];
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, accum), (0,_define_property/* default */.Z)({}, epoch, claimable));
                        }, {})
                    ];
            }
        });
    });
    return function getClaimStatuses(account, epochs, address) {
        return _ref.apply(this, arguments);
    };
}();
var getPredictionData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(address) {
        var staticCalls, ref, ref1, currentEpoch, ref2, intervalSeconds, ref3, minBetAmount, ref4, paused, ref5, treasuryFee;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    staticCalls = [
                        "currentEpoch",
                        "intervalSeconds",
                        "minBetAmount",
                        "paused",
                        "treasuryFee"
                    ].map(function(method) {
                        return {
                            address: address,
                            name: method,
                            params: []
                        };
                    });
                    return [
                        4,
                        (0,multicall/* multicallv3 */.OF)({
                            abi: predictions,
                            calls: staticCalls
                        })
                    ];
                case 1:
                    ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        5
                    ]), ref1 = (0,_sliced_to_array/* default */.Z)(ref[0], 1), currentEpoch = ref1[0], ref2 = (0,_sliced_to_array/* default */.Z)(ref[1], 1), intervalSeconds = ref2[0], ref3 = (0,_sliced_to_array/* default */.Z)(ref[2], 1), minBetAmount = ref3[0], ref4 = (0,_sliced_to_array/* default */.Z)(ref[3], 1), paused = ref4[0], ref5 = (0,_sliced_to_array/* default */.Z)(ref[4], 1), treasuryFee = ref5[0];
                    return [
                        2,
                        {
                            status: paused ? types/* PredictionStatus.PAUSED */.Gw.PAUSED : types/* PredictionStatus.LIVE */.Gw.LIVE,
                            currentEpoch: currentEpoch.toNumber(),
                            intervalSeconds: intervalSeconds.toNumber(),
                            minBetAmount: minBetAmount.toString(),
                            treasuryFee: treasuryFee.toNumber()
                        }
                    ];
            }
        });
    });
    return function getPredictionData(address) {
        return _ref.apply(this, arguments);
    };
}();
var getRoundsData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(epochs, address) {
        var calls, response;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    calls = epochs.map(function(epoch) {
                        return {
                            address: address,
                            name: "rounds",
                            params: [
                                epoch
                            ]
                        };
                    });
                    return [
                        4,
                        (0,multicall/* multicallv3 */.OF)({
                            abi: predictions,
                            calls: calls
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response
                    ];
            }
        });
    });
    return function getRoundsData(epochs, address) {
        return _ref.apply(this, arguments);
    };
}();
var makeFutureRoundResponse = function(epoch, startTimestamp) {
    return {
        epoch: epoch,
        startTimestamp: startTimestamp,
        lockTimestamp: null,
        closeTimestamp: null,
        lockPrice: null,
        closePrice: null,
        totalAmount: bignumbers/* Zero.toJSON */._Y.toJSON(),
        bullAmount: bignumbers/* Zero.toJSON */._Y.toJSON(),
        bearAmount: bignumbers/* Zero.toJSON */._Y.toJSON(),
        rewardBaseCalAmount: bignumbers/* Zero.toJSON */._Y.toJSON(),
        rewardAmount: bignumbers/* Zero.toJSON */._Y.toJSON(),
        oracleCalled: false,
        lockOracleId: null,
        closeOracleId: null
    };
};
var makeRoundData = function(rounds) {
    return rounds.reduce(function(accum, round) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, accum), (0,_define_property/* default */.Z)({}, round.epoch.toString(), round));
    }, {});
};
var serializePredictionsLedgerResponse = function(ledgerResponse) {
    return {
        position: ledgerResponse.position === 0 ? types/* BetPosition.BULL */.Tu.BULL : types/* BetPosition.BEAR */.Tu.BEAR,
        amount: ledgerResponse.amount.toJSON(),
        claimed: ledgerResponse.claimed
    };
};
var makeLedgerData = function(account, ledgers, epochs) {
    return ledgers.reduce(function(accum, ledgerResponse, index) {
        if (!ledgerResponse) {
            return accum;
        }
        // If the amount is zero that means the user did not bet
        if (ledgerResponse.amount.eq(0)) {
            return accum;
        }
        var epoch = epochs[index].toString();
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, accum), (0,_define_property/* default */.Z)({}, account, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, accum[account]), (0,_define_property/* default */.Z)({}, epoch, serializePredictionsLedgerResponse(ledgerResponse)))));
    }, {});
};
/**
 * Serializes the return from the "rounds" call for redux
 */ var serializePredictionsRoundsResponse = function(response) {
    var epoch = response.epoch, startTimestamp = response.startTimestamp, lockTimestamp = response.lockTimestamp, closeTimestamp = response.closeTimestamp, lockPrice = response.lockPrice, closePrice = response.closePrice, totalAmount = response.totalAmount, bullAmount = response.bullAmount, bearAmount = response.bearAmount, rewardBaseCalAmount = response.rewardBaseCalAmount, rewardAmount = response.rewardAmount, oracleCalled = response.oracleCalled, lockOracleId = response.lockOracleId, closeOracleId = response.closeOracleId;
    return {
        oracleCalled: oracleCalled,
        epoch: epoch.toNumber(),
        startTimestamp: startTimestamp.eq(0) ? null : startTimestamp.toNumber(),
        lockTimestamp: lockTimestamp.eq(0) ? null : lockTimestamp.toNumber(),
        closeTimestamp: closeTimestamp.eq(0) ? null : closeTimestamp.toNumber(),
        lockPrice: lockPrice.eq(0) ? null : lockPrice.toJSON(),
        closePrice: closePrice.eq(0) ? null : closePrice.toJSON(),
        totalAmount: totalAmount.toJSON(),
        bullAmount: bullAmount.toJSON(),
        bearAmount: bearAmount.toJSON(),
        rewardBaseCalAmount: rewardBaseCalAmount.toJSON(),
        rewardAmount: rewardAmount.toJSON(),
        lockOracleId: lockOracleId.toString(),
        closeOracleId: closeOracleId.toString()
    };
};
/**
 * Parse serialized values back into BigNumber
 * BigNumber values are stored with the "toJSON()" method, e.g  { type: "BigNumber", hex: string }
 */ var parseBigNumberObj = function(data) {
    return Object.keys(data).reduce(function(accum, key) {
        var value = data[key];
        if (value && (value === null || value === void 0 ? void 0 : value.type) === "BigNumber") {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, accum), (0,_define_property/* default */.Z)({}, key, bignumber/* BigNumber.from */.O$.from(value)));
        }
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, accum), (0,_define_property/* default */.Z)({}, key, value));
    }, {});
};
var fetchUsersRoundsLength = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(account, address) {
        var contract, length, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    contract = (0,contractHelpers/* getPredictionsContract */.qi)(address);
                    return [
                        4,
                        contract.getUserRoundsLength(account)
                    ];
                case 1:
                    length = _state.sent();
                    return [
                        2,
                        length
                    ];
                case 2:
                    e = _state.sent();
                    return [
                        2,
                        bignumbers/* Zero */._Y
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchUsersRoundsLength(account, address) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Fetches rounds a user has participated in
 */ var fetchUserRounds = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(account) {
        var cursor, size, address, contract, ref, rounds, ledgers, e;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    cursor = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 0, size = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : config/* ROUNDS_PER_PAGE */.yg, address = _arguments.length > 3 ? _arguments[3] : void 0;
                    contract = (0,contractHelpers/* getPredictionsContract */.qi)(address);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        contract.getUserRounds(account, cursor, size)
                    ];
                case 2:
                    ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        2
                    ]), rounds = ref[0], ledgers = ref[1];
                    return [
                        2,
                        rounds.reduce(function(accum, round, index) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, accum), (0,_define_property/* default */.Z)({}, round.toString(), serializePredictionsLedgerResponse(ledgers[index])));
                        }, {})
                    ];
                case 3:
                    e = _state.sent();
                    // When the results run out the contract throws an error.
                    return [
                        2,
                        null
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchUserRounds(account) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 89890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "WR": function() { return /* binding */ useChartView; },
  "Dh": function() { return /* binding */ useCollectWinningModalProps; },
  "n3": function() { return /* binding */ useGetBetByEpoch; },
  "XM": function() { return /* binding */ useGetBufferSeconds; },
  "dJ": function() { return /* binding */ useGetCurrentEpoch; },
  "Gc": function() { return /* binding */ useGetCurrentHistoryPage; },
  "ds": function() { return /* binding */ useGetCurrentRoundCloseTimestamp; },
  "sz": function() { return /* binding */ useGetHasHistoryLoaded; },
  "pw": function() { return /* binding */ useGetHistory; },
  "J7": function() { return /* binding */ useGetHistoryFilter; },
  "m3": function() { return /* binding */ useGetIntervalSeconds; },
  "Wx": function() { return /* binding */ useGetIsClaimable; },
  "dW": function() { return /* binding */ useGetIsFetchingHistory; },
  "YY": function() { return /* binding */ useGetLeaderboardFilters; },
  "Gy": function() { return /* binding */ useGetLeaderboardHasMoreResults; },
  "AC": function() { return /* binding */ useGetLeaderboardLoadingState; },
  "HF": function() { return /* binding */ useGetLeaderboardResults; },
  "Ok": function() { return /* binding */ useGetLeaderboardSkip; },
  "eI": function() { return /* binding */ useGetMinBetAmount; },
  "nB": function() { return /* binding */ useGetOrFetchLeaderboardAddressResult; },
  "hU": function() { return /* binding */ useGetPredictionsStatus; },
  "We": function() { return /* binding */ useGetPredictionsTreasuryFee; },
  "Z_": function() { return /* binding */ useGetRoundsByCloseOracleId; },
  "dm": function() { return /* binding */ useGetSortedRounds; },
  "Aq": function() { return /* binding */ useGetSortedRoundsCurrentEpoch; },
  "YF": function() { return /* binding */ useIsChartPaneOpen; },
  "e": function() { return /* binding */ useIsHistoryPaneOpen; },
  "b1": function() { return /* binding */ useStatModalProps; }
});

// UNUSED EXPORTS: useGetAddressResult, useGetSelectedAddress

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(97119);
// EXTERNAL MODULE: ./src/contexts/LocalRedux/useLocalDispatch.ts
var useLocalDispatch = __webpack_require__(29807);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/contexts/LocalRedux/Provider.tsx
var Provider = __webpack_require__(13351);
;// CONCATENATED MODULE: ./src/contexts/LocalRedux/useSelector.ts


var useSelector = (0,es/* createSelectorHook */.gR)(Provider/* LocalContext */.A);
/* harmony default export */ var LocalRedux_useSelector = (useSelector);

// EXTERNAL MODULE: ./src/state/predictions/index.ts
var predictions = __webpack_require__(24179);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@ethersproject/bignumber/lib.esm/bignumber.js
var bignumber = __webpack_require__(2593);
// EXTERNAL MODULE: ./node_modules/lodash/orderBy.js
var orderBy = __webpack_require__(75472);
var orderBy_default = /*#__PURE__*/__webpack_require__.n(orderBy);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var reselect_es = __webpack_require__(68697);
// EXTERNAL MODULE: ./src/state/predictions/helpers.ts + 6 modules
var helpers = __webpack_require__(79279);
;// CONCATENATED MODULE: ./src/state/predictions/selectors.ts







var selectCurrentEpoch = function(state) {
    return state.currentEpoch;
};
var selectRounds = function(state) {
    return state.rounds;
};
var selectLedgers = function(state) {
    return state.ledgers;
};
var selectClaimableStatuses = function(state) {
    return state.claimableStatuses;
};
var selectMinBetAmount = function(state) {
    return state.minBetAmount;
};
var selectIntervalSeconds = function(state) {
    return state.intervalSeconds;
};
var makeGetBetByEpochSelector = function(account, epoch) {
    return (0,reselect_es/* createSelector */.P1)([
        selectLedgers
    ], function(bets) {
        if (!bets[account]) {
            return null;
        }
        if (!bets[account][epoch]) {
            return null;
        }
        return (0,helpers/* parseBigNumberObj */.zN)(bets[account][epoch]);
    });
};
var makeGetIsClaimableSelector = function(epoch) {
    return (0,reselect_es/* createSelector */.P1)([
        selectClaimableStatuses
    ], function(claimableStatuses) {
        return claimableStatuses[epoch] || false;
    });
};
var getRoundsByCloseOracleIdSelector = (0,reselect_es/* createSelector */.P1)([
    selectRounds
], function(rounds) {
    return Object.keys(rounds).reduce(function(accum, epoch) {
        var parsed = (0,helpers/* parseBigNumberObj */.zN)(rounds[epoch]);
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, accum), (0,_define_property/* default */.Z)({}, parsed.closeOracleId, parsed));
    }, {});
});
var getBigNumberRounds = (0,reselect_es/* createSelector */.P1)([
    selectRounds
], function(rounds) {
    return Object.keys(rounds).reduce(function(accum, epoch) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, accum), (0,_define_property/* default */.Z)({}, epoch, (0,helpers/* parseBigNumberObj */.zN)(rounds[epoch])));
    }, {});
});
var getSortedRoundsSelector = (0,reselect_es/* createSelector */.P1)([
    getBigNumberRounds
], function(rounds) {
    return orderBy_default()(Object.values(rounds), [
        "epoch"
    ], [
        "asc"
    ]);
});
var getSortedRoundsCurrentEpochSelector = (0,reselect_es/* createSelector */.P1)([
    selectCurrentEpoch,
    getSortedRoundsSelector
], function(currentEpoch, sortedRounds) {
    return {
        currentEpoch: currentEpoch,
        rounds: sortedRounds
    };
});
var getMinBetAmountSelector = (0,reselect_es/* createSelector */.P1)([
    selectMinBetAmount
], bignumber/* BigNumber.from */.O$.from);
var getCurrentRoundCloseTimestampSelector = (0,reselect_es/* createSelector */.P1)([
    selectCurrentEpoch,
    getBigNumberRounds,
    selectIntervalSeconds
], function(currentEpoch, rounds, intervalSeconds) {
    if (!currentEpoch) {
        return undefined;
    }
    var currentRound = rounds[currentEpoch - 1];
    if (!currentRound) {
        return undefined;
    }
    if (!currentRound.closeTimestamp) {
        return currentRound.lockTimestamp + intervalSeconds;
    }
    return currentRound.closeTimestamp;
});

;// CONCATENATED MODULE: ./src/state/predictions/hooks.ts






var useGetRoundsByCloseOracleId = function() {
    return LocalRedux_useSelector(getRoundsByCloseOracleIdSelector);
};
var useGetSortedRounds = function() {
    return LocalRedux_useSelector(getSortedRoundsSelector);
};
var useGetSortedRoundsCurrentEpoch = function() {
    return LocalRedux_useSelector(getSortedRoundsCurrentEpochSelector);
};
var useGetBetByEpoch = function(account, epoch) {
    var getBetByEpochSelector = (0,react.useMemo)(function() {
        return makeGetBetByEpochSelector(account, epoch);
    }, [
        account,
        epoch
    ]);
    return LocalRedux_useSelector(getBetByEpochSelector);
};
var useGetIsClaimable = function(epoch) {
    var getIsClaimableSelector = (0,react.useMemo)(function() {
        return makeGetIsClaimableSelector(epoch);
    }, [
        epoch
    ]);
    return LocalRedux_useSelector(getIsClaimableSelector);
};
var useIsHistoryPaneOpen = function() {
    return LocalRedux_useSelector(function(state) {
        return state.isHistoryPaneOpen;
    });
};
var useIsChartPaneOpen = function() {
    return LocalRedux_useSelector(function(state) {
        return state.isChartPaneOpen;
    });
};
var useChartView = function() {
    return LocalRedux_useSelector(function(state) {
        return state.chartView;
    });
};
var useGetCurrentEpoch = function() {
    return LocalRedux_useSelector(function(state) {
        return state.currentEpoch;
    });
};
var useGetIntervalSeconds = function() {
    return LocalRedux_useSelector(function(state) {
        return state.intervalSeconds;
    });
};
var useGetPredictionsStatus = function() {
    return LocalRedux_useSelector(function(state) {
        return state.status;
    });
};
var useGetPredictionsTreasuryFee = function() {
    return LocalRedux_useSelector(function(state) {
        return state.treasuryFee;
    });
};
var useGetHistoryFilter = function() {
    return LocalRedux_useSelector(function(state) {
        return state.historyFilter;
    });
};
var useGetHasHistoryLoaded = function() {
    return LocalRedux_useSelector(function(state) {
        return state.hasHistoryLoaded;
    });
};
var useGetCurrentHistoryPage = function() {
    return LocalRedux_useSelector(function(state) {
        return state.currentHistoryPage;
    });
};
var useGetMinBetAmount = function() {
    return LocalRedux_useSelector(getMinBetAmountSelector);
};
var useGetBufferSeconds = function() {
    return LocalRedux_useSelector(function(state) {
        return state.bufferSeconds;
    });
};
var useGetIsFetchingHistory = function() {
    return LocalRedux_useSelector(function(state) {
        return state.isFetchingHistory;
    });
};
var useGetHistory = function() {
    return LocalRedux_useSelector(function(state) {
        return state.history;
    });
};
/**
 * The current round's lock timestamp will not be set immediately so we return an estimate until then
 */ var useGetCurrentRoundCloseTimestamp = function() {
    return LocalRedux_useSelector(getCurrentRoundCloseTimestampSelector);
};
// Leaderboard
var useGetLeaderboardLoadingState = function() {
    return LocalRedux_useSelector(function(state) {
        return state.leaderboard.loadingState;
    });
};
var useGetLeaderboardResults = function() {
    return LocalRedux_useSelector(function(state) {
        return state.leaderboard.results;
    });
};
var useGetLeaderboardFilters = function() {
    return LocalRedux_useSelector(function(state) {
        return state.leaderboard.filters;
    });
};
var useGetLeaderboardSkip = function() {
    return LocalRedux_useSelector(function(state) {
        return state.leaderboard.skip;
    });
};
var useGetLeaderboardHasMoreResults = function() {
    return LocalRedux_useSelector(function(state) {
        return state.leaderboard.hasMoreResults;
    });
};
var useGetAddressResult = function(account) {
    return LocalRedux_useSelector(function(state) {
        return state.leaderboard.addressResults[account];
    });
};
var useGetOrFetchLeaderboardAddressResult = function(account) {
    var addressResult = useGetAddressResult(account);
    var dispatch = (0,useLocalDispatch/* default */.Z)();
    (0,react.useEffect)(function() {
        var address = (0,utils/* isAddress */.UJ)(account);
        // If address result is null it means we already tried fetching the results and none came back
        if (!addressResult && addressResult !== null && address) {
            dispatch((0,predictions/* fetchAddressResult */.nI)(account));
        }
    }, [
        dispatch,
        account,
        addressResult
    ]);
    return addressResult;
};
var useGetSelectedAddress = function() {
    return LocalRedux_useSelector(function(state) {
        return state.leaderboard.selectedAddress;
    });
};
// Because Modal Component is rendered outside the Prediction Page contexts
// We have to pass local state as props instead of retrieving directly in component
var useStatModalProps = function(account) {
    var selectedAddress = useGetSelectedAddress();
    var address = account || selectedAddress;
    var result = useGetOrFetchLeaderboardAddressResult(address);
    var leaderboardLoadingState = useGetLeaderboardLoadingState();
    return {
        address: address,
        result: result,
        leaderboardLoadingState: leaderboardLoadingState
    };
};
var useCollectWinningModalProps = function() {
    var isLoadingHistory = useGetIsFetchingHistory();
    var history = useGetHistory();
    return {
        isLoadingHistory: isLoadingHistory,
        history: history
    };
};


/***/ }),

/***/ 24179:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E3": function() { return /* binding */ initialState; },
/* harmony export */   "G$": function() { return /* binding */ setLeaderboardFilter; },
/* harmony export */   "Mk": function() { return /* binding */ filterNextPageLeaderboard; },
/* harmony export */   "S9": function() { return /* binding */ fetchPredictionData; },
/* harmony export */   "Ub": function() { return /* binding */ fetchLedgerData; },
/* harmony export */   "WB": function() { return /* binding */ markAsCollected; },
/* harmony export */   "Yq": function() { return /* binding */ setHistoryFilter; },
/* harmony export */   "bq": function() { return /* binding */ setChartView; },
/* harmony export */   "dG": function() { return /* binding */ filterLeaderboard; },
/* harmony export */   "l3": function() { return /* binding */ setSelectedAddress; },
/* harmony export */   "nI": function() { return /* binding */ fetchAddressResult; },
/* harmony export */   "nQ": function() { return /* binding */ setChartPaneState; },
/* harmony export */   "uP": function() { return /* binding */ fetchNodeHistory; },
/* harmony export */   "uw": function() { return /* binding */ initializePredictions; },
/* harmony export */   "vR": function() { return /* binding */ setHistoryPaneState; }
/* harmony export */ });
/* unused harmony exports fetchHistory, predictionsSlice */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(36305);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(70655);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5700);
/* harmony import */ var _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(2593);
/* harmony import */ var _ethersproject_units__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(61744);
/* harmony import */ var lodash_maxBy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84753);
/* harmony import */ var lodash_maxBy__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_maxBy__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82492);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_merge__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_range__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96026);
/* harmony import */ var lodash_range__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_range__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_pickBy__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35937);
/* harmony import */ var lodash_pickBy__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_pickBy__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var state_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96470);
/* harmony import */ var config_constants_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75759);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81272);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79279);
/* harmony import */ var _global_actions__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(51904);



















var initialState = {
    status: state_types__WEBPACK_IMPORTED_MODULE_4__/* .PredictionStatus.INITIAL */ .Gw.INITIAL,
    chartView: state_types__WEBPACK_IMPORTED_MODULE_4__/* .PredictionsChartView.Chainlink */ .RU.Chainlink,
    isLoading: false,
    isHistoryPaneOpen: false,
    isChartPaneOpen: false,
    isFetchingHistory: false,
    historyFilter: state_types__WEBPACK_IMPORTED_MODULE_4__/* .HistoryFilter.ALL */ .dZ.ALL,
    currentEpoch: 0,
    intervalSeconds: 300,
    minBetAmount: "10000000000000",
    bufferSeconds: 60,
    rounds: {},
    history: [],
    treasuryFee: 500,
    totalHistory: 0,
    currentHistoryPage: 1,
    hasHistoryLoaded: false,
    ledgers: {},
    claimableStatuses: {},
    leaderboard: {
        selectedAddress: null,
        loadingState: config_constants_types__WEBPACK_IMPORTED_MODULE_5__/* .FetchStatus.Idle */ .iF.Idle,
        filters: {
            address: null,
            orderBy: "netETH",
            timePeriod: "all"
        },
        skip: 0,
        hasMoreResults: false,
        addressResults: {},
        results: []
    }
};
var initializePredictions = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createAsyncThunk */ .hg)("predictions/initialize", /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function() {
    var account, extra, marketData, epochs, roundsResponse, initialRoundData, initializedData, ref, ledgerResponses, claimableStatuses;
    var _arguments = arguments;
    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                account = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : null, extra = (_arguments.length > 1 ? _arguments[1] : void 0).extra;
                return [
                    4,
                    (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .getPredictionData */ .n)(extra.address)
                ];
            case 1:
                marketData = _state.sent();
                epochs = marketData.currentEpoch > _config__WEBPACK_IMPORTED_MODULE_6__/* .PAST_ROUND_COUNT */ .v9 ? lodash_range__WEBPACK_IMPORTED_MODULE_2___default()(marketData.currentEpoch, marketData.currentEpoch - _config__WEBPACK_IMPORTED_MODULE_6__/* .PAST_ROUND_COUNT */ .v9) : [
                    marketData.currentEpoch
                ];
                return [
                    4,
                    (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .getRoundsData */ .$8)(epochs, extra.address)
                ];
            case 2:
                roundsResponse = _state.sent();
                initialRoundData = roundsResponse.reduce(function(accum, roundResponse) {
                    var reduxNodeRound = (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .serializePredictionsRoundsResponse */ .WB)(roundResponse);
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, accum), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, reduxNodeRound.epoch.toString(), reduxNodeRound));
                }, {});
                initializedData = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, marketData), {
                    rounds: initialRoundData,
                    ledgers: {},
                    claimableStatuses: {}
                });
                if (!account) {
                    return [
                        2,
                        initializedData
                    ];
                }
                return [
                    4,
                    Promise.all([
                        (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .getLedgerData */ .Tq)(account, epochs, extra.address),
                        (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .getClaimStatuses */ .jG)(account, epochs, extra.address)
                    ])
                ];
            case 3:
                ref = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"].apply */ .Z.apply(void 0, [
                    _state.sent(),
                    2
                ]), ledgerResponses = ref[0], claimableStatuses = ref[1];
                return [
                    2,
                    lodash_merge__WEBPACK_IMPORTED_MODULE_1___default()({}, initializedData, {
                        ledgers: (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .makeLedgerData */ .a8)(account, ledgerResponses, epochs),
                        claimableStatuses: claimableStatuses
                    })
                ];
        }
    });
}));
var fetchPredictionData = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createAsyncThunk */ .hg)("predictions/fetchPredictionData", /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function() {
    var account, extra, ref, status, currentEpoch, intervalSeconds, minBetAmount, treasuryFee, liveCurrentAndRecent, roundsResponse, roundData, publicData, epochs, ref1, ledgerResponses, claimableStatuses;
    var _arguments = arguments;
    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                account = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : null, extra = (_arguments.length > 1 ? _arguments[1] : void 0).extra;
                return [
                    4,
                    (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .getPredictionData */ .n)(extra.address)
                ];
            case 1:
                ref = _state.sent(), status = ref.status, currentEpoch = ref.currentEpoch, intervalSeconds = ref.intervalSeconds, minBetAmount = ref.minBetAmount, treasuryFee = ref.treasuryFee;
                liveCurrentAndRecent = [
                    currentEpoch,
                    currentEpoch - 1,
                    currentEpoch - 2
                ];
                return [
                    4,
                    (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .getRoundsData */ .$8)(liveCurrentAndRecent, extra.address)
                ];
            case 2:
                roundsResponse = _state.sent();
                roundData = roundsResponse.reduce(function(accum, round) {
                    if (!round) {
                        return accum;
                    }
                    var reduxNodeRound = (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .serializePredictionsRoundsResponse */ .WB)(round);
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, accum), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, reduxNodeRound.epoch.toString(), reduxNodeRound));
                }, {});
                publicData = {
                    status: status,
                    currentEpoch: currentEpoch,
                    intervalSeconds: intervalSeconds,
                    minBetAmount: minBetAmount,
                    rounds: roundData,
                    ledgers: {},
                    claimableStatuses: {},
                    treasuryFee: treasuryFee
                };
                if (!account) {
                    return [
                        2,
                        publicData
                    ];
                }
                epochs = currentEpoch > _config__WEBPACK_IMPORTED_MODULE_6__/* .PAST_ROUND_COUNT */ .v9 ? lodash_range__WEBPACK_IMPORTED_MODULE_2___default()(currentEpoch, currentEpoch - _config__WEBPACK_IMPORTED_MODULE_6__/* .PAST_ROUND_COUNT */ .v9) : [
                    currentEpoch
                ];
                return [
                    4,
                    Promise.all([
                        (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .getLedgerData */ .Tq)(account, epochs, extra.address),
                        (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .getClaimStatuses */ .jG)(account, epochs, extra.address)
                    ])
                ];
            case 3:
                ref1 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"].apply */ .Z.apply(void 0, [
                    _state.sent(),
                    2
                ]), ledgerResponses = ref1[0], claimableStatuses = ref1[1];
                return [
                    2,
                    lodash_merge__WEBPACK_IMPORTED_MODULE_1___default()({}, publicData, {
                        ledgers: (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .makeLedgerData */ .a8)(account, ledgerResponses, epochs),
                        claimableStatuses: claimableStatuses
                    })
                ];
        }
    });
}));
var fetchLedgerData = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createAsyncThunk */ .hg)("predictions/fetchLedgerData", function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(param, param1) {
        var account, epochs, extra, ledgers;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    account = param.account, epochs = param.epochs, extra = param1.extra;
                    return [
                        4,
                        (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .getLedgerData */ .Tq)(account, epochs, extra.address)
                    ];
                case 1:
                    ledgers = _state.sent();
                    return [
                        2,
                        (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .makeLedgerData */ .a8)(account, ledgers, epochs)
                    ];
            }
        });
    });
    return function(_, _1) {
        return _ref.apply(this, arguments);
    };
}());
var fetchHistory = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createAsyncThunk */ .hg)("predictions/fetchHistory", function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(param, param1) {
        var account, claimed, extra, response, transformer, bets;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    account = param.account, claimed = param.claimed, extra = param1.extra;
                    return [
                        4,
                        (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .getBetHistory */ .Fr)({
                            user: account.toLowerCase(),
                            claimed: claimed
                        }, undefined, undefined, extra.api, extra.token.symbol)
                    ];
                case 1:
                    response = _state.sent();
                    transformer = (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .transformBetResponse */ .ld)(extra.token.symbol);
                    bets = response.map(transformer);
                    return [
                        2,
                        {
                            account: account,
                            bets: bets
                        }
                    ];
            }
        });
    });
    return function(_, _1) {
        return _ref.apply(this, arguments);
    };
}());
var fetchNodeHistory = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createAsyncThunk */ .hg)("predictions/fetchNodeHistory", function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(param, param1) {
        var account, _page, page, getState, extra, userRoundsLength, emptyResult, maxPages, cursor, size, userRounds, epochs, ref, roundData, claimableStatuses, bufferSeconds, bets;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    account = param.account, _page = param.page, page = _page === void 0 ? 1 : _page, getState = param1.getState, extra = param1.extra;
                    return [
                        4,
                        (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .fetchUsersRoundsLength */ .t$)(account, extra.address)
                    ];
                case 1:
                    userRoundsLength = _state.sent();
                    emptyResult = {
                        bets: [],
                        claimableStatuses: {},
                        totalHistory: userRoundsLength.toNumber()
                    };
                    maxPages = userRoundsLength.lte(_config__WEBPACK_IMPORTED_MODULE_6__/* .ROUNDS_PER_PAGE */ .yg) ? 1 : Math.ceil(userRoundsLength.toNumber() / _config__WEBPACK_IMPORTED_MODULE_6__/* .ROUNDS_PER_PAGE */ .yg);
                    if (userRoundsLength.eq(0)) {
                        return [
                            2,
                            emptyResult
                        ];
                    }
                    if (page > maxPages) {
                        return [
                            2,
                            emptyResult
                        ];
                    }
                    cursor = userRoundsLength.sub(_config__WEBPACK_IMPORTED_MODULE_6__/* .ROUNDS_PER_PAGE */ .yg * page);
                    size = maxPages === page ? userRoundsLength.sub(_config__WEBPACK_IMPORTED_MODULE_6__/* .ROUNDS_PER_PAGE */ .yg * (page - 1)) // Previous page's cursor
                    .toNumber() : _config__WEBPACK_IMPORTED_MODULE_6__/* .ROUNDS_PER_PAGE */ .yg;
                    return [
                        4,
                        (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .fetchUserRounds */ .oO)(account, cursor.lt(0) ? 0 : cursor.toNumber(), size, extra.address)
                    ];
                case 2:
                    userRounds = _state.sent();
                    if (!userRounds) {
                        return [
                            2,
                            emptyResult
                        ];
                    }
                    epochs = Object.keys(userRounds).map(function(epochStr) {
                        return Number(epochStr);
                    });
                    return [
                        4,
                        Promise.all([
                            (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .getRoundsData */ .$8)(epochs, extra.address),
                            (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .getClaimStatuses */ .jG)(account, epochs, extra.address)
                        ])
                    ];
                case 3:
                    ref = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"].apply */ .Z.apply(void 0, [
                        _state.sent(),
                        2
                    ]), roundData = ref[0], claimableStatuses = ref[1];
                    bufferSeconds = getState().bufferSeconds;
                    bets = roundData.reduce(function(accum, round) {
                        var reduxRound = (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .serializePredictionsRoundsResponse */ .WB)(round);
                        var ledger = userRounds[reduxRound.epoch];
                        var ledgerAmount = _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_16__/* .BigNumber.from */ .O$.from(ledger.amount);
                        var closePrice = round.closePrice ? parseFloat((0,_ethersproject_units__WEBPACK_IMPORTED_MODULE_17__.formatUnits)(round.closePrice, 8)) : null;
                        var lockPrice = round.lockPrice ? parseFloat((0,_ethersproject_units__WEBPACK_IMPORTED_MODULE_17__.formatUnits)(round.lockPrice, 8)) : null;
                        var getRoundPosition = function() {
                            if (!closePrice) {
                                return null;
                            }
                            if (round.closePrice.eq(round.lockPrice)) {
                                return state_types__WEBPACK_IMPORTED_MODULE_4__/* .BetPosition.HOUSE */ .Tu.HOUSE;
                            }
                            return round.closePrice.gt(round.lockPrice) ? state_types__WEBPACK_IMPORTED_MODULE_4__/* .BetPosition.BULL */ .Tu.BULL : state_types__WEBPACK_IMPORTED_MODULE_4__/* .BetPosition.BEAR */ .Tu.BEAR;
                        };
                        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(accum).concat([
                            {
                                id: null,
                                hash: null,
                                amount: parseFloat((0,_ethersproject_units__WEBPACK_IMPORTED_MODULE_17__.formatUnits)(ledgerAmount)),
                                position: ledger.position,
                                claimed: ledger.claimed,
                                claimedAt: null,
                                claimedHash: null,
                                claimedBNB: 0,
                                claimedNetBNB: 0,
                                createdAt: null,
                                updatedAt: null,
                                block: 0,
                                round: {
                                    id: null,
                                    epoch: round.epoch.toNumber(),
                                    failed: (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .getHasRoundFailed */ .HJ)(reduxRound.oracleCalled, reduxRound.closeTimestamp, bufferSeconds),
                                    startBlock: null,
                                    startAt: round.startTimestamp ? round.startTimestamp.toNumber() : null,
                                    startHash: null,
                                    lockAt: round.lockTimestamp ? round.lockTimestamp.toNumber() : null,
                                    lockBlock: null,
                                    lockPrice: lockPrice,
                                    lockHash: null,
                                    lockRoundId: round.lockOracleId ? round.lockOracleId.toString() : null,
                                    closeRoundId: round.closeOracleId ? round.closeOracleId.toString() : null,
                                    closeHash: null,
                                    closeAt: null,
                                    closePrice: closePrice,
                                    closeBlock: null,
                                    totalBets: 0,
                                    totalAmount: parseFloat((0,_ethersproject_units__WEBPACK_IMPORTED_MODULE_17__.formatUnits)(round.totalAmount)),
                                    bullBets: 0,
                                    bullAmount: parseFloat((0,_ethersproject_units__WEBPACK_IMPORTED_MODULE_17__.formatUnits)(round.bullAmount)),
                                    bearBets: 0,
                                    bearAmount: parseFloat((0,_ethersproject_units__WEBPACK_IMPORTED_MODULE_17__.formatUnits)(round.bearAmount)),
                                    position: getRoundPosition()
                                }
                            }, 
                        ]);
                    }, []);
                    return [
                        2,
                        {
                            bets: bets,
                            claimableStatuses: claimableStatuses,
                            page: page,
                            totalHistory: userRoundsLength.toNumber()
                        }
                    ];
            }
        });
    });
    return function(_, _1) {
        return _ref.apply(this, arguments);
    };
}());
// Leaderboard
var filterLeaderboard = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createAsyncThunk */ .hg)("predictions/filterLeaderboard", function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(param, param1) {
        var filters, extra, usersResponse, transformer;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    filters = param.filters, extra = param1.extra;
                    return [
                        4,
                        (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .getPredictionUsers */ .D)({
                            skip: 0,
                            orderBy: filters.orderBy,
                            where: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({
                                totalBets_gte: _config__WEBPACK_IMPORTED_MODULE_6__/* .LEADERBOARD_MIN_ROUNDS_PLAYED */ .eQ
                            }, "".concat(filters.orderBy, "_gt"), 0)
                        }, extra.api, extra.token.symbol)
                    ];
                case 1:
                    usersResponse = _state.sent();
                    transformer = (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .transformUserResponse */ .r3)(extra.token.symbol);
                    return [
                        2,
                        {
                            results: usersResponse
                        }
                    ];
            }
        });
    // return { results: usersResponse.map(transformer)}
    });
    return function(_, _1) {
        return _ref.apply(this, arguments);
    };
}());
var fetchAddressResult = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createAsyncThunk */ .hg)("predictions/fetchAddressResult", function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(account, param) {
        var rejectWithValue, extra, userResponse;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    rejectWithValue = param.rejectWithValue, extra = param.extra;
                    return [
                        4,
                        (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .getPredictionUser */ .s9)(account, extra.api, extra.token.symbol)
                    ];
                case 1:
                    userResponse = _state.sent();
                    if (!userResponse) {
                        return [
                            2,
                            rejectWithValue(account)
                        ];
                    }
                    return [
                        2,
                        {
                            account: account,
                            data: (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .transformUserResponse */ .r3)(extra.token.symbol)(userResponse)
                        }
                    ];
            }
        });
    });
    return function(account, _) {
        return _ref.apply(this, arguments);
    };
}());
var filterNextPageLeaderboard = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createAsyncThunk */ .hg)("predictions/filterNextPageLeaderboard", function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(skip, param) {
        var getState, extra, state, usersResponse, transformer;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    getState = param.getState, extra = param.extra;
                    state = getState();
                    return [
                        4,
                        (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .getPredictionUsers */ .D)({
                            skip: skip,
                            orderBy: state.leaderboard.filters.orderBy,
                            where: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({
                                totalBets_gte: _config__WEBPACK_IMPORTED_MODULE_6__/* .LEADERBOARD_MIN_ROUNDS_PLAYED */ .eQ
                            }, "".concat(state.leaderboard.filters.orderBy, "_gt"), 0)
                        }, extra.api, extra.token.symbol)
                    ];
                case 1:
                    usersResponse = _state.sent();
                    transformer = (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .transformUserResponse */ .r3)(extra.token.symbol);
                    return [
                        2,
                        {
                            results: usersResponse,
                            skip: skip
                        }
                    ];
            }
        });
    // return { results: usersResponse.map(transformer), skip }
    });
    return function(skip, _) {
        return _ref.apply(this, arguments);
    };
}());
var predictionsSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createSlice */ .oM)({
    name: "predictions",
    initialState: initialState,
    reducers: {
        setLeaderboardFilter: function(state, action) {
            state.leaderboard.filters = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, state.leaderboard.filters, action.payload);
            // Anytime we filters change we need to reset back to page 1
            state.leaderboard.skip = 0;
            state.leaderboard.hasMoreResults = true;
        },
        setHistoryPaneState: function(state, action) {
            state.isHistoryPaneOpen = action.payload;
            state.historyFilter = state_types__WEBPACK_IMPORTED_MODULE_4__/* .HistoryFilter.ALL */ .dZ.ALL;
        },
        setChartPaneState: function(state, action) {
            state.isChartPaneOpen = action.payload;
        },
        setChartView: function(state, action) {
            state.chartView = action.payload;
        },
        setHistoryFilter: function(state, action) {
            state.historyFilter = action.payload;
        },
        markAsCollected: function(state, action) {
            state.claimableStatuses = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, state.claimableStatuses, action.payload);
        },
        setSelectedAddress: function(state, action) {
            state.leaderboard.selectedAddress = action.payload;
        }
    },
    extraReducers: function(builder) {
        builder.addCase(_global_actions__WEBPACK_IMPORTED_MODULE_8__/* .resetUserState */ .t, function(state) {
            state.claimableStatuses = {};
            state.ledgers = {};
            state.isFetchingHistory = false;
            state.history = [];
            state.hasHistoryLoaded = false;
            state.totalHistory = 0;
            state.currentHistoryPage = 1;
        });
        // Leaderboard filter
        builder.addCase(filterLeaderboard.pending, function(state) {
            // Only mark as loading if we come from Fetched. This allows initialization.
            if (state.leaderboard.loadingState === config_constants_types__WEBPACK_IMPORTED_MODULE_5__/* .FetchStatus.Fetched */ .iF.Fetched) {
                state.leaderboard.loadingState = config_constants_types__WEBPACK_IMPORTED_MODULE_5__/* .FetchStatus.Fetching */ .iF.Fetching;
            }
        });
        builder.addCase(filterLeaderboard.fulfilled, function(state, action) {
            var results = action.payload.results;
            state.leaderboard.loadingState = config_constants_types__WEBPACK_IMPORTED_MODULE_5__/* .FetchStatus.Fetched */ .iF.Fetched;
            state.leaderboard.results = results;
            if (results.length < _helpers__WEBPACK_IMPORTED_MODULE_7__/* .LEADERBOARD_RESULTS_PER_PAGE */ .ub) {
                state.leaderboard.hasMoreResults = false;
            } else {
                state.leaderboard.hasMoreResults = true;
            }
            // Populate address results to reduce calls
            state.leaderboard.addressResults = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, state.leaderboard.addressResults, results.reduce(function(accum, result) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, accum), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, result.id, result));
            }, {}));
        });
        // Leaderboard account result
        builder.addCase(fetchAddressResult.pending, function(state) {
            state.leaderboard.loadingState = config_constants_types__WEBPACK_IMPORTED_MODULE_5__/* .FetchStatus.Fetching */ .iF.Fetching;
        });
        builder.addCase(fetchAddressResult.fulfilled, function(state, action) {
            var _payload = action.payload, account = _payload.account, data = _payload.data;
            state.leaderboard.loadingState = config_constants_types__WEBPACK_IMPORTED_MODULE_5__/* .FetchStatus.Fetched */ .iF.Fetched;
            state.leaderboard.addressResults[account] = data;
        });
        builder.addCase(fetchAddressResult.rejected, function(state, action) {
            state.leaderboard.loadingState = config_constants_types__WEBPACK_IMPORTED_MODULE_5__/* .FetchStatus.Fetched */ .iF.Fetched // TODO: should handle error
            ;
            state.leaderboard.addressResults[action.payload] = null;
        });
        // Leaderboard next page
        builder.addCase(filterNextPageLeaderboard.pending, function(state) {
            state.leaderboard.loadingState = config_constants_types__WEBPACK_IMPORTED_MODULE_5__/* .FetchStatus.Fetching */ .iF.Fetching;
        });
        builder.addCase(filterNextPageLeaderboard.fulfilled, function(state, action) {
            var _payload = action.payload, results = _payload.results, skip = _payload.skip;
            state.leaderboard.loadingState = config_constants_types__WEBPACK_IMPORTED_MODULE_5__/* .FetchStatus.Fetched */ .iF.Fetched;
            state.leaderboard.results = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(state.leaderboard.results).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(results));
            state.leaderboard.skip = skip;
            if (results.length < _helpers__WEBPACK_IMPORTED_MODULE_7__/* .LEADERBOARD_RESULTS_PER_PAGE */ .ub) {
                state.leaderboard.hasMoreResults = false;
            } else {
                state.leaderboard.hasMoreResults = true;
            }
        });
        // Ledger (bet) records
        builder.addCase(fetchLedgerData.fulfilled, function(state, action) {
            state.ledgers = lodash_merge__WEBPACK_IMPORTED_MODULE_1___default()({}, state.ledgers, action.payload);
        });
        // Get static market data
        builder.addCase(fetchPredictionData.fulfilled, function(state, action) {
            var _payload = action.payload, status = _payload.status, currentEpoch = _payload.currentEpoch, intervalSeconds = _payload.intervalSeconds, minBetAmount = _payload.minBetAmount, rounds = _payload.rounds, claimableStatuses = _payload.claimableStatuses, ledgers = _payload.ledgers;
            var allRoundData = lodash_merge__WEBPACK_IMPORTED_MODULE_1___default()({}, state.rounds, rounds);
            var newRounds = lodash_pickBy__WEBPACK_IMPORTED_MODULE_3___default()(allRoundData, function(value, key) {
                return Number(key) > state.currentEpoch - _config__WEBPACK_IMPORTED_MODULE_6__/* .PAST_ROUND_COUNT */ .v9;
            });
            // If the round has change add a new future round
            if (state.currentEpoch !== currentEpoch) {
                var newestRound = lodash_maxBy__WEBPACK_IMPORTED_MODULE_0___default()(Object.values(state.rounds), "epoch");
                var futureRound = (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .makeFutureRoundResponse */ .CM)(newestRound.epoch + 1, newestRound.startTimestamp + intervalSeconds + _config__WEBPACK_IMPORTED_MODULE_6__/* .ROUND_BUFFER */ .fq);
                newRounds = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, newRounds), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, futureRound.epoch, futureRound));
            }
            state.status = status;
            state.currentEpoch = currentEpoch;
            state.intervalSeconds = intervalSeconds;
            state.minBetAmount = minBetAmount;
            state.claimableStatuses = lodash_merge__WEBPACK_IMPORTED_MODULE_1___default()({}, state.claimableStatuses, claimableStatuses);
            state.ledgers = lodash_merge__WEBPACK_IMPORTED_MODULE_1___default()({}, state.ledgers, ledgers);
            state.rounds = newRounds;
        });
        // Initialize predictions
        builder.addCase(initializePredictions.fulfilled, function(state, action) {
            var _payload = action.payload, status = _payload.status, currentEpoch = _payload.currentEpoch, intervalSeconds = _payload.intervalSeconds, rounds = _payload.rounds, claimableStatuses = _payload.claimableStatuses, ledgers = _payload.ledgers, treasuryFee = _payload.treasuryFee;
            var futureRounds = [];
            var currentRound = rounds[currentEpoch];
            for(var i = 1; i <= _config__WEBPACK_IMPORTED_MODULE_6__/* .FUTURE_ROUND_COUNT */ .ND; i++){
                futureRounds.push((0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .makeFutureRoundResponse */ .CM)(currentEpoch + i, currentRound.startTimestamp + intervalSeconds * i));
            }
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, state), {
                status: status,
                currentEpoch: currentEpoch,
                intervalSeconds: intervalSeconds,
                claimableStatuses: claimableStatuses,
                ledgers: ledgers,
                rounds: lodash_merge__WEBPACK_IMPORTED_MODULE_1___default()({}, rounds, (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .makeRoundData */ .D5)(futureRounds)),
                treasuryFee: treasuryFee
            });
        });
        // Show History
        builder.addCase(fetchHistory.pending, function(state) {
            state.isFetchingHistory = true;
        });
        builder.addCase(fetchHistory.rejected, function(state) {
            state.isFetchingHistory = false;
        });
        builder.addCase(fetchHistory.fulfilled, function(state, action) {
            var _payload = action.payload, account = _payload.account, bets = _payload.bets;
            state.isFetchingHistory = false;
            var _account;
            state.history[account] = lodash_merge__WEBPACK_IMPORTED_MODULE_1___default()([], (_account = state.history[account]) !== null && _account !== void 0 ? _account : [], bets);
        });
        // History from the node
        builder.addCase(fetchNodeHistory.pending, function(state) {
            state.isFetchingHistory = true;
        });
        builder.addCase(fetchNodeHistory.rejected, function(state) {
            state.isFetchingHistory = false;
        });
        builder.addCase(fetchNodeHistory.fulfilled, function(state, action) {
            var _payload = action.payload, bets = _payload.bets, claimableStatuses = _payload.claimableStatuses, page = _payload.page, totalHistory = _payload.totalHistory;
            state.isFetchingHistory = false;
            state.history = page === 1 ? bets : (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(state.history).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(bets));
            state.claimableStatuses = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, state.claimableStatuses, claimableStatuses);
            state.hasHistoryLoaded = state.history.length === totalHistory || bets.length === 0;
            state.totalHistory = totalHistory;
            state.currentHistoryPage = page;
        });
    }
});
var _actions = predictionsSlice.actions;
// Actions
var setChartPaneState = _actions.setChartPaneState, setChartView = _actions.setChartView, setHistoryFilter = _actions.setHistoryFilter, setHistoryPaneState = _actions.setHistoryPaneState, markAsCollected = _actions.markAsCollected, setLeaderboardFilter = _actions.setLeaderboardFilter, setSelectedAddress = _actions.setSelectedAddress;
/* harmony default export */ __webpack_exports__["ZP"] = (predictionsSlice.reducer);


/***/ }),

/***/ 65238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ ConfigProvider; },
/* harmony export */   "ZR": function() { return /* binding */ useConfig; }
/* harmony export */ });
/* unused harmony export ConfigContext */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var ConfigContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(null);
function useConfig() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(ConfigContext);
}
function ConfigProvider(param) {
    var children = param.children, config = param.config;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ConfigContext.Provider, {
        value: config,
        children: children
    });
}


/***/ }),

/***/ 63322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ context_PredictionConfigProviders; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/contexts/LocalRedux/Provider.tsx
var Provider = __webpack_require__(13351);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 2 modules
var redux_toolkit_esm = __webpack_require__(5700);
;// CONCATENATED MODULE: ./src/contexts/LocalRedux/makeStore.ts

function makeStore(reducer) {
    var preloadedState = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : undefined, extraArgument = arguments.length > 2 ? arguments[2] : void 0;
    return (0,redux_toolkit_esm/* configureStore */.xC)({
        reducer: reducer,
        middleware: function(getDefaultMiddleware) {
            return getDefaultMiddleware({
                thunk: {
                    extraArgument: extraArgument
                }
            });
        },
        preloadedState: preloadedState
    });
}

// EXTERNAL MODULE: ./src/state/types.ts
var types = __webpack_require__(96470);
// EXTERNAL MODULE: ./src/state/predictions/index.ts
var predictions = __webpack_require__(24179);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/views/Predictions/context/ConfigProvider.tsx
var ConfigProvider = __webpack_require__(65238);
// EXTERNAL MODULE: ./src/config/constants/contracts.ts
var contracts = __webpack_require__(87338);
// EXTERNAL MODULE: ./src/config/constants/endpoints.ts
var endpoints = __webpack_require__(6680);
// EXTERNAL MODULE: ./src/utils/addressHelpers.ts
var addressHelpers = __webpack_require__(69352);
// EXTERNAL MODULE: ./packages/tokens/src/index.ts + 5 modules
var src = __webpack_require__(40370);
// EXTERNAL MODULE: ./node_modules/@ethersproject/bignumber/lib.esm/bignumber.js
var bignumber = __webpack_require__(2593);
;// CONCATENATED MODULE: ./src/views/Predictions/context/config.ts





var DEFAULT_MIN_PRICE_USD_DISPLAYED = bignumber/* BigNumber.from */.O$.from(10000);
var MAIN_CHAIN = 250;
/* harmony default export */ var context_config = ({
    BNB: {
        address: (0,addressHelpers/* getAddress */.Kn)(contracts/* default.predictionsBNB */.Z.predictionsBNB, MAIN_CHAIN),
        api: endpoints/* GRAPH_API_PREDICTION_BNB */.GZ,
        chainlinkOracleAddress: (0,addressHelpers/* getAddress */.Kn)(contracts/* default.chainlinkOracleBNB */.Z.chainlinkOracleBNB, MAIN_CHAIN),
        minPriceUsdDisplayed: DEFAULT_MIN_PRICE_USD_DISPLAYED,
        displayedDecimals: 4,
        token: src/* bscTokens.bnb */.ds.bnb
    },
    CAKE: {
        address: (0,addressHelpers/* getAddress */.Kn)(contracts/* default.predictionsCAKE */.Z.predictionsCAKE, MAIN_CHAIN),
        api: endpoints/* GRAPH_API_PREDICTION_CAKE */.fO,
        chainlinkOracleAddress: (0,addressHelpers/* getAddress */.Kn)(contracts/* default.chainlinkOracleCAKE */.Z.chainlinkOracleCAKE, MAIN_CHAIN),
        minPriceUsdDisplayed: DEFAULT_MIN_PRICE_USD_DISPLAYED,
        displayedDecimals: 4,
        token: src/* CAKE_FTM */.z_
    }
});

;// CONCATENATED MODULE: ./src/views/Predictions/context/PredictionConfigProviders.tsx









var PREDICTION_TOKEN_KEY = "prediction-token";
var PredictionConfigProviders = function(param) {
    var children = param.children;
    var query = (0,router.useRouter)().query;
    var token = query.token;
    var ref = (0,react.useState)(function() {
        // const initToken = localStorage?.getItem(PREDICTION_TOKEN_KEY) as PredictionSupportedSymbol
        var initToken = "CAKE";
        // if ([PredictionSupportedSymbol.BNB, PredictionSupportedSymbol.CAKE].includes(initToken)) {
        return initToken;
        // }
        return types/* PredictionSupportedSymbol.CAKE */.ru.CAKE;
    }), selectedToken = ref[0], setConfig = ref[1];
    // useEffect(() => {
    //   const upperToken = _toUpper(token as string) as PredictionSupportedSymbol
    //   if ([PredictionSupportedSymbol.BNB, PredictionSupportedSymbol.CAKE].includes(upperToken)) {
    //     setConfig(upperToken)
    //     localStorage?.setItem(PREDICTION_TOKEN_KEY, upperToken)
    //   }
    // }, [token])
    var config = (0,react.useMemo)(function() {
        return context_config[selectedToken];
    }, [
        selectedToken
    ]);
    var store = (0,react.useMemo)(function() {
        return makeStore(predictions/* default */.ZP, predictions/* initialState */.E3, config);
    }, [
        config
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfigProvider/* default */.ZP, {
        config: config,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Provider/* default */.Z, {
            store: store,
            children: children
        })
    });
};
/* harmony default export */ var context_PredictionConfigProviders = (PredictionConfigProviders);


/***/ })

}]);